import React from 'react'
import './Ministries.css'
import '../../../App.css'
import '../SubLinks.css'
import MinistryLinks from '../MinistryLinks';
import { Link } from 'react-router-dom'
import '../Blockquote.css'
import { FaQuoteLeft, FaQuoteRight } from "react-icons/fa6";

function Nursery() {
    return (
        <div>
            <div className='hero-container nursery half'>
                <h1></h1>
            </div>
        <div className='main-grid-container'>
          <div className='main-grid-item'>
        <MinistryLinks/>
        </div>
        <div className='main-grid-item'>
        <div className='main with-sublinks'>
                <h1>Nursery</h1>
                    <div className='blockquote-container'>
                    <blockquote> We shall not all sleep, but we shall all be changed.
                        <cite> - 1 Corinthians 15:51</cite>
                    </blockquote>
                    </div>
                
                <h2>Parental Assistance</h2>
                <p>
                The Nursery Ministry (0-4 years old) at Grace Community Fellowship is committed to assisting parents in fulfilling the scriptural admonition to train their children in a way that honors the Lord (Ephesians 6:4; Deuteronomy 6:6-9). Our goal is to help prepare children to participate in regular Sunday morning worship. 
                </p>
                <h2>Biblical Teaching</h2>
                <p>
                At the heart of our Nursery Ministry is basic Bible teaching which is designed to clearly present to every child their need for the Savior, Jesus Christ (Romans 3:23; 5:8).
                </p>
                <h2>Nursery Coverage</h2>
                <p>Nursery is provided Sunday mornings and Wednesday evenings. On a periodic basis, the Nursery will be available to assist families participating in special training or teaching events.</p>
                <br/>
                <p>
                If you are interested in learning more about our Nursery Ministry please <Link to='/contact-us' className='p-link'>contact us</Link>.
                </p>
                <br/>
                <p><em>NOTE: All nursery workers and those working with any minors are required to have background checks in keeping with GCF policies.</em></p>
                
            </div>
        </div>
        </div>
        </div>
    )
}

export default Nursery
